var map = {
	"./HeaderSkull_Music.svg": "WQB+",
	"./HeaderSkull_Specials.svg": "39kk",
	"./HeaderSkull_Studio.svg": "RRkX",
	"./HeaderSkull_Team.svg": "d1Ef",
	"./HeaderSkull_Work-old.svg": "HsnX",
	"./HeaderSkull_Work.svg": "Yh4r"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22T4";